/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
/* eslint-disable no-case-declarations */
import { actionTypes, InitialState } from './rootContext';

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.CLOSE_DRAWER_SNACKBAR:
      state.drawerSnackbar = {
        isOpen: false,
        message: '',
      };

      return;
    case actionTypes.CLOSE_GLOBAL_SNACKBAR:
      state.globalSnackbar = {
        isOpen: false,
        message: '',
      };

      return;

    case actionTypes.SHOW_DRAWER_SNACKBAR:
      state.drawerSnackbar = action.snackbar;
      state.drawerSnackbar.isOpen = true;

      return;
    case actionTypes.SHOW_GLOBAL_SNACKBAR:
      state.globalSnackbar = action.snackbar;
      state.globalSnackbar.isOpen = true;
      return;
    case actionTypes.WORKSPACE_ERROR:
      state.hasWorkspaceError = action.payload;
      return;
    default:
      return InitialState;
  }
};
